import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnsPortalConfigurationPageSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Section>
        <Skeleton variant="text" width={240} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={220} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={260} height={28} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>
    </Styles.Container>
  )
}

export default ReturnsPortalConfigurationPageSkeleton
